import React, { useEffect, useState } from "react";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";

const AddPermission = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });
  const [permission, setPermission] = useState({
    name: "",
    keyname: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPermission((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const savePermission = async (e) => {
    e.preventDefault();
    let error = false;
    //console.log(post);
    //return;
    if (permission.name === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter permission name.",
        };
      });
      return;
    }
    if (permission.keyname === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter permission keyname.",
        };
      });
      return;
    }

    if (!error) {
      await axios
        .post(
          localStorage.getItem("basurl") + "/permissions",
          {
            name: permission.name,
            keyname: permission.keyname,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
          setPermission({ title: "", description: "", medias: [] });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} permission="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done! " : "Oops! "}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}

        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Name: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              placeholder="Enter permission name"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={permission.name}
            />
          </div>
        </div>
        <div className="row mg-t-4">
          <label className="col-sm-3 form-control-label">
            Rank: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-9 mg-sm-t-0">
            <input
              id="keyname"
              name="keyname"
              className="form-control"
              placeholder="Enter post description"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChange}
              value={permission.keyname}
            />
          </div>
        </div>
        <div className="form-layout-footer mg-t-30 tx-right">
          <NavLink to="/admin/permissions"> My Permissions </NavLink> &nbsp;
          &nbsp; &nbsp;
          <button
            onClick={savePermission}
            className="btn btn-info"
            style={{ cursor: "pointer" }}
          >
            Save
          </button>
          &nbsp;&nbsp;
        </div>
      </div>
    </>
  );
};

export default AddPermission;
